function Navigate(url) {
    var failMessage = 'failed to retrieve '; // we can say caption of Menu item like failed to retrieve content of <menuitem name like EditsGrid etc>
    var renderDiv = 'divBodyRender';
    TryResetMenuTimer('Navigate');

    var callCallBackDirectly = function () {
        MainMenu_AjaxGetWithRawUrl(url, failMessage, renderDiv);
    };

    RegisterCallBackToNavigationQueue(callCallBackDirectly);
    RegisterCallBackToPopupUnload(unloadReactPopup);

    SetupNavigateAwayWithCallBacks('MainMenu_AjaxGetWithRawUrl', null, url, failMessage, renderDiv);
}

function SetupNavigateAwayWithCallBacks(callback, cancelCallBack) {
    TryResetMenuTimer('TitleClick');
    var newCallBack = CreateArguments(callback, 2, arguments)
    if (!NavigateAwayWithCallBackAndCancelCallBack(newCallBack, cancelCallBack, sessionStorage.BaseUrl, 'Account')) {
        eval(newCallBack);      
    } 
}


function RegisterCallBackToNavigationQueue(callCallBackDirectly) {
    if (window.OMN_NAVIGATION_QUEUE === undefined || window.OMN_NAVIGATION_QUEUE === null)
        window.OMN_NAVIGATION_QUEUE = [];
    window.OMN_NAVIGATION_QUEUE.push({ level: "TOP", navigateFn: callCallBackDirectly});
}

function RegisterCallBackToPopupUnload(callback) {
    if (!window.OMN_UNLOAD_REACT_POPUP) {
        window.OMN_UNLOAD_REACT_POPUP = callback;
    }
}

//url will have url + data(querystring)
function MainMenu_AjaxGetWithRawUrl(url, failMessage, divLoading) {
    var optionalParams = {};
    optionalParams.RenderDiv = divLoading;
    AjaxGet(url, {}, failMessage, divLoading, MainMenu_AjaxDisplayInDiv_Callback, null, optionalParams);
}

function ManageMyAccount(action, controller, pv) {
    var optParams = { RenderDiv: "divBodyRender" };
    MainMenu_AjaxGet(
        {
            partialView: pv
        },
        controller, action, "Failed to retrieve MyAccount objects: ", optParams.RenderDiv,
        MainMenu_AjaxDisplayInDiv_Callback, null, optParams);
}  

function MainMenu_AjaxGet(obData, controllerName, actionName, failMessage, divLoading, callbackSuccess, callbackFail, optionalParams) {
    var ajaxUrl = sessionStorage.BaseUrl;
    ajaxUrl = ajaxUrl.replace("zzzACTzzz", actionName).replace("zzzCONTzzz", controllerName);
    AjaxGet(ajaxUrl, obData, failMessage, divLoading, callbackSuccess, callbackFail, optionalParams);
}

function AjaxGet(ajaxUrl, obData, failMessage, divLoading, callbackSuccess, callbackFail, optionalParams) {
    Kendo_ShowOrHideLoadingImage(divLoading, true);
    var request = $.ajax({
        url: ajaxUrl,
        //async: false,//not needed anymore? (added to fix TFS 19381) - it prevents spinner and it might cause timeout on some browsers
        method: "GET",
        data: obData,
        success: function (data) {
            if (AjaxResult_CommonResultHandled(data)) {
                Kendo_ShowOrHideLoadingImage(divLoading, false);
                return;
            }
            if (callbackSuccess)
                callbackSuccess(data, optionalParams);
            Kendo_ShowOrHideLoadingImage(divLoading, false);
        },
        error: function (result) {
            Kendo_ShowOrHideLoadingImage(divLoading, false);
            if (callbackFail)
                callbackFail(result, optionalParams);
            if (failMessage != undefined && failMessage != "")
                ReportGridAjax_ErrorHandler(failMessage, result);
        }
    });
}

function MainMenu_AjaxDisplayInDiv_Callback(data, optParams) {
    //clear the body render   
    $(optParams.RenderDiv).empty();
    if (window.UnMountOnDemandReactBody !== undefined)
        window.UnMountOnDemandReactBody();
    RenderHtmlIntoControl(data, optParams.RenderDiv, false);
}

/**
 * Unloads popup React component
 * **/
function unloadReactPopup() {
    if (!window.UnMountOnDemandReactPopup) {
        return;
    }
    // timer is a quick fix and should be reviewed
    // 300ms so dialog closing animation has time to work to the end
    setTimeout(function() {
        window.UnMountOnDemandReactPopup();
    }, 300);
}
